require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/node_modules/strophejs-plugins/pubsub/strophe.pubsub.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/strophejs-plugins/pubsub/strophe.pubsub.js
 ** module id = 13
 ** module chunks = 0
 **/